import { getExportHistoryFile } from '@/services/call-log-service/call-log-service';
import { message } from 'antd';
import { useState } from 'react';

export const useExportHistoryFile = () => {
  const [isPending, setIsPending] = useState<{ [key: number]: boolean }>({});
  const [messageApi, contextHolder] = message.useMessage();

  const prepareCSV = async (id: number) => {
    try {
      setIsPending((prev) => ({ ...prev, [id]: true }));
      const { file } = await getExportHistoryFile(id);

      if (file) {
        const link = document.createElement('a');
        link.href = file;
        link.setAttribute(
          'download',
          `exported_analytic_data_${new Date().toLocaleDateString()}_${id}.csv`
        );
        document.body.appendChild(link);
        link.click();

        link.parentNode?.removeChild(link);

        messageApi.success('File has been downloaded successfully!');
      } else {
        messageApi.error('No link found to download the file');
      }
    } finally {
      setIsPending((prev) => ({ ...prev, [id]: false }));
    }
  };

  return { prepareCSV, isPending, exportContextHolder: contextHolder };
};
